import { IAlbum } from 'redhotpie-shared-lib/interfaces/IImages';
import { Dispatch } from 'redux';
import { IPaginationMessage } from '../api/conversationApi';
import * as types from '../constants/actionTypes';
import { TYPE_GROUP_CHAT } from '../constants/chatTypes';
import * as constants from '../constants/constants';
import * as messageStatus from '../constants/messageStatus';
import * as messageUtils from '../functions/messageUtils';
import { IAction } from '../interfaces/IAction';
import { IApiResponse } from '../interfaces/IApiResponse';
import conversationService from '../services/conversationService';
import privateAlbumService from '../services/privateAlbumService';
import * as myStore from '../store/myStore';
import { beginAjaxCall } from './ajaxStatusActions';
import * as conversationInboxAction from './conversationInboxAction';
import * as messageAction from './messageActions';
import { removeGrantedAccess } from './privateAlbumAction';
import { IConversation } from 'redhotpie-shared-lib/interfaces/IConversation';
import ChatMessage from 'redhotpie-shared-lib/models/chatMessage';
import { MessageReducerAction } from 'redhotpie-shared-lib/reducers/messageReducer';

interface Conversation {
  id: string;
  isGroup: boolean;
  peerVcard: {
    xmppId: string;
    userId?: string;
  };
  folders: string[];
  pinned: boolean;
  message: {
    id: string;
  };
}

interface AlbumInfoResponse {
  value: {
    success: boolean;
    data: {
      items: {
        hasAccess: boolean;
        galleryId: string;
        friendId: string;
      }[];
    };
  };
}

function getLoginXmppId(): string {
  const login = myStore.getStore().getState().loginReducer;
  if (login && login.userInfo) {
    return login.userInfo.xmppId;
  }
  return '';
}

export function getConversationDetailPending(params?: any): IAction {
  return { type: types.LOAD_CONVERSATION_DETAIL_PENDING, params };
}

export function getConversationDetailSuccess(data: ChatMessage[], shouldRemoveOldMessages?: boolean, peerXmppId?: string) {
  return {
    type: types.LOAD_CONVERSATION_DETAIL_SUCCESS,
    messages: data || [],
    shouldRemoveOldMessages: !!shouldRemoveOldMessages,
    peerXmppId,
  };
}

export function updateListConversationIdsDeleted(data: any): IAction {
  return { type: types.UPDATE_LIST_CONVERSATION_IDS_DELETED, data };
}

export function getConversationDetailFailure(params?: any): IAction {
  return { type: types.LOAD_CONVERSATION_DETAIL_FAILURE, params };
}

export function getConversationDetailRequestSuccess(): IAction {
  return { type: types.LOAD_CONVERSATION_DETAIL_REQUEST_SUCCESS, data: {} };
}

export function getOrCreateConversationFail(params: any): IAction {
  return { type: types.GET_OR_CREATE_CONVERSATIONS_FAIL, failParams: params };
}

export function getConversationDetailRequest(peerXmppId: string): IAction {
  return { type: types.LOAD_CONVERSATION_DETAIL_REQUEST, peerXmppId };
}

export function pinConversationSuccess(xmppId: string): IAction {
  return { type: types.PIN_CONVERSATION_SUCCESS, data: xmppId };
}

export function unpinConversationSuccess(xmppId: string): IAction {
  return { type: types.UNPIN_CONVERSATION_SUCCESS, data: xmppId };
}

export function deleteSharedMediaSuccess(params: any): IAction {
  return { type: types.LOAD_CONVERSATION_DETAIL_PENDING, params };
}

export function deleteConversationSuccess(xmppId: string, folderIds: number[], isPin: boolean, isGroup = false, remove?: boolean) {
  const folderItems = myStore.getStore().getState().foldersReducer.items;
  let newFolderItems: any[] = [];
  if (folderIds && folderIds.length > 0) {
    folderItems.forEach((item: any) => {
      if (folderIds.find(e => e === item.id)) {
        const _conversationCount = item.conversationCount > 0 ? item.conversationCount - 1 : 0;
        newFolderItems.push(
          Object.assign({}, item, {
            conversationCount: _conversationCount,
          })
        );
      } else {
        newFolderItems.push(item);
      }
    });
  } else {
    newFolderItems = folderItems;
  }
  return {
    type: types.DELETE_CONVERSATION_SUCCESS,
    data: { xmppId, newFolderItems, isPin, isGroup, remove },
  };
}

export function updateModalDeleteSuccess(result: any) {
  return { type: types.UPDATE_MODAL_DELETE, data: result };
}

export function deleteMessageSuccess(msgId: string) {
  return { type: types.DELETE_MESSAGE_SUCCESS, data: msgId };
}

export function deleteMessageFail(msgId: string) {
  return { type: types.DELETE_MESSAGE_FAIL, data: msgId };
}

export function getAlbumPhotosSuccess(mid: string, imageData: any[]) {
  return { type: types.GET_PHOTOS_SUCCESS, imageData, mid };
}

export function getAlbumPhotosDenied(medias: any, xmppId: string) {
  return { type: types.DELETE_SHARED_MEDIA_SUCCESS, medias, xmppId };
}

export function getConversationDetails(loginUser: any, peerUser: any, paramsData?: any) {
  let params = paramsData;
  if (!params) {
    params = {};
    const { messageReducer } = myStore.getStore().getState();
    const messages = messageUtils.getMessagesByUser(messageReducer, peerUser);
    const hasMyMsg = messages.findIndex(i => i.bySelf);
    const lengthMsg = messages.length - 1;
    if (hasMyMsg !== -1) {
      try {
        for (let i = lengthMsg; i >= 0; i--) {
          if (messages[i].bySelf) {
            params.lastSynchAt = messages[i].time;
            break;
          }
        }
      } catch (e) {
        params.pageSize = constants.PAGING_DEFAULT.PAGE_SIZE_MESSAGE;
        params.lastSynchAt = 0;
        console.error('Error get time last my message in conversation', e);
      }
    } else {
      params.pageSize = constants.PAGING_DEFAULT.PAGE_SIZE_MESSAGE;
      params.lastSynchAt = 0;
    }
  }

  return (dispatch: Dispatch) => {
    dispatch(getConversationDetailPending());
    return conversationService
      .getConversationsDetails(peerUser.xmppId, loginUser, peerUser, params)
      .then((res: any) => {
        if (res.success) {
          dispatch(getConversationDetailSuccess(res.data.items, params.lastSynchAt === 0, peerUser.xmppId));
        } else {
          dispatch(getConversationDetailFailure());
        }
        dispatch(getConversationDetailRequestSuccess());
        return res;
      })
      .catch((e: any) => {
        dispatch(getConversationDetailFailure());
        return { success: false, error: e };
      });
  };
}

export function deleteConversation(
  receiverXmppid: string,
  converstationId: number,
  folderIds: number[],
  isPin: boolean,
  lastMessageInConversationId: string
) {
  return (dispatch: any) => {
    return conversationService.deleteConversation(receiverXmppid).then((res: IApiResponse) => {
      if (res.success) {
        dispatch(messageAction.sendDelete(lastMessageInConversationId, receiverXmppid, true, converstationId));
        dispatch(deleteConversationSuccess(receiverXmppid, folderIds, isPin));
        dispatch(messageAction.deletePeerAllMessage(receiverXmppid));
      } else {
        console.log('ERROR: conversationDetailAction/deleteConversation', res.message);
      }
      return res;
    });
  };
}

export function deleteListConversations(listConversation: IConversation[], signal = true) {
  return (dispatch: any, getStore: any) => {
    const idsSingleChat: number[] = [];
    const idsGroupChat: number[] = [];
    const peerUserIdsSingleChat: number[] = [];
    for (let i = 0; i < listConversation.length; i++) {
      const itm = listConversation[i];
      if (itm?.isGroup) {
        idsGroupChat.push(itm.id);
      } else {
        idsSingleChat.push(itm.id);
      }
      if (itm?.peerVcard?.userId) {
        peerUserIdsSingleChat.push(itm?.peerVcard?.userId);
      }
    }
    // Check to remove album access before delete conversation
    const arrAPICheckAlbum: Promise<IApiResponse>[] = [];
    peerUserIdsSingleChat.forEach(userId => arrAPICheckAlbum.push(privateAlbumService.getAlbumInfos(userId)));
    if (peerUserIdsSingleChat.length) {
      Promise.all(arrAPICheckAlbum).then(response => {
        response?.forEach?.(res => {
          if (res?.value?.success) {
            const galleryGrantedIds: number[] = [];
            res?.value?.data?.items?.forEach((album: IAlbum) => {
              if (album?.hasAccess) {
                galleryGrantedIds.push(album?.galleryId);
              }
            });
            if (galleryGrantedIds?.length > 0) {
              dispatch(removeGrantedAccess(galleryGrantedIds, res?.value?.data?.items[0]?.friendId, getLoginXmppId()));
            }
          }
        });
      });
    }
    const arrAPICall: Promise<any>[] = [];
    // Delete list group chat
    if (idsGroupChat.length > 0) {
      arrAPICall.push(conversationService.deleteListConversationGroup({ Ids: idsGroupChat }));
    }
    // Delete list Single chat
    if (idsSingleChat.length > 0) {
      arrAPICall.push(conversationService.deleteListConversations({ Ids: idsSingleChat }));
    }

    return Promise.all(arrAPICall).then(res => {
      if (res[0].success) {
        listConversation.forEach(_conv => {
          const folderIds = _conv.folders;
          const receiverXmppid = _conv.peerVcard.xmppId;
          const isPin = _conv.pinned;
          // For single
          const converstationId = _conv.id;
          const lastMessageInConversationId = _conv.message.id;

          if (!_conv?.isGroup) {
            if (signal) {
              dispatch(messageAction.sendDelete(lastMessageInConversationId, receiverXmppid, true, converstationId));
            }
            dispatch(messageAction.deletePeerAllMessage(receiverXmppid));
          }
          dispatch(deleteConversationSuccess(receiverXmppid, folderIds, isPin, _conv?.isGroup));
        });

        dispatch(updateListConversationIdsDeleted({ Ids: listConversation.map(i => i.id) }));
      }

      return res[0];
    });
  };
}

export function pinOrUnpinConversation({
  pinned,
  xmppId,
  isGroupChat = false,
}: {
  pinned: boolean;
  xmppId: string;
  isGroupChat?: boolean;
}) {
  return (dispatch: Dispatch<IAction>) => {
    return conversationService.pinOrUnpinConversation({ pinned, xmppId, isGroupChat }).then((res: any) => {
      if (res.success) {
        pinned ? dispatch(pinConversationSuccess(xmppId)) : dispatch(unpinConversationSuccess(xmppId));
      } else {
        console.log('ERROR: conversationDetailAction/pinOrUnpinConversation', res.message);
      }
      return res;
    });
  };
}

export function updateModalDelete(res: any) {
  return (dispatch: Dispatch<IAction>) => {
    dispatch(updateModalDeleteSuccess(res));
  };
}

export function deleteMessage(deletedChatMessage: any, isLastConversationMessage: boolean, previousChatMessage: any) {
  return (dispatch: any) => {
    dispatch(beginAjaxCall());
    const isGroup = deletedChatMessage.type === TYPE_GROUP_CHAT;
    if (deletedChatMessage?.error) {
      // Only remove message error in locally
      dispatch(messageAction.removeMessage(deletedChatMessage.id));
      return Promise.resolve({ success: true });
    }
    return conversationService
      .deleteMessage(deletedChatMessage.id, isLastConversationMessage, previousChatMessage, isGroup)
      .then((res: any) => {
        if (res.success) {
          const peerXmppId = messageUtils.getPeerXmppId(deletedChatMessage);
          dispatch(messageAction.updateMessageStatus(deletedChatMessage.id, messageStatus.STATUS_DELETED));

          if (deletedChatMessage.from !== peerXmppId) {
            dispatch(messageAction.sendDelete(deletedChatMessage.id, peerXmppId, false, 0, isGroup));
          }

          // update last conversation's message in Inbox
          if (isLastConversationMessage) {
            dispatch(conversationInboxAction.deleteConversationLastMessageSuccess(peerXmppId, deletedChatMessage.id));
          }
        } else {
          console.log('ERROR: conversationDetailAction/deleteMessage', res.message);
          dispatch(deleteMessageFail(deletedChatMessage.id));
        }
        return res;
      });
  };
}

// Get images list for an album
export function getAlbumPhotos(msgId: string, userId: string | number, galleryId: string, imageCount?: number) {
  return (dispatch: Dispatch<IAction>) => {
    return privateAlbumService.getAlbumPhotos(userId, galleryId, imageCount).then((res: any) => {
      if (res.success) {
        const imagesList = res && res.data && res.data.items ? res.data.items : [];
        if (msgId) dispatch(getAlbumPhotosSuccess(msgId, imagesList));
      } else {
        console.log('ERROR: MessageImage/getData', res.message);
        if (msgId) dispatch(getAlbumPhotosSuccess(msgId, []));
      }
      return res;
    });
  };
}

export function selectMessage(msgId: string | null, isEdit = false) {
  return { type: types.UPDATE_MESSAGE_ID_SELECTED, msgId, isEdit: isEdit };
}

export function getSharedMedia(
  xmppId: string,
  isGroup = false,
  { lastSynchAt, pageSize }: IPaginationMessage = {
    lastSynchAt: 0,
    pageSize: 25,
  },
  isSaveRedux = true
) {
  return (dispatch: Dispatch<IAction>) => {
    dispatch({ type: types.GET_SHARED_MEDIA_REQUEST, xmppId });
    return conversationService
      .getSharedMedia(xmppId, isGroup, {
        lastSynchAt,
        pageSize,
      })
      .then((res: any) => {
        if (res?.success && isSaveRedux) {
          dispatch({
            type: types.GET_SHARED_MEDIA_SUCCESS,
            data: { ...res.data },
            xmppId,
            lastSynchAt,
          });
        } else {
          dispatch({ type: types.GET_SHARED_MEDIA_FAILED, xmppId });
        }
        return res;
      });
  };
}

export function getSharedMediaByDirection(xmppId: string, isGroup = false, pageSize = 25, referenceMediaTime: string, direction: string) {
  return (dispatch: Dispatch<IAction>) => {
    dispatch({ type: types.GET_SHARED_MEDIA_REQUEST, xmppId });
    return conversationService.getSharedMediaByDirection(xmppId, isGroup, pageSize, referenceMediaTime, direction).then((res: any) => {
      if (res?.success) {
        // dispatch({
        //     type: types.GET_SHARED_MEDIA_SUCCESS,
        //     data: {...res.data},
        //     xmppId,
        //     lastSynchAt
        // })
      } else {
        dispatch({ type: types.GET_SHARED_MEDIA_FAILED, xmppId });
      }
      return res;
    });
  };
}

export function deleteSharedMedia(xmppId: string, isGroup = false, mediaIds: string[], needDispatchSharedImageReducer: boolean) {
  return (dispatch: Dispatch<IAction>) => {
    return conversationService.deleteSharedMedias(xmppId, isGroup, mediaIds).then((res: any) => {
      if (res?.success && needDispatchSharedImageReducer) {
        dispatch({ type: types.DELETE_SHARED_MEDIA_SUCCESS, mediaIds, xmppId });
      }
      return res;
    });
  };
}
